import { HEADER_HEIGHT } from 'Constants/Theme'

const styles = {
  contained: {
    position: 'absolute',
    width: '100%',
    height: `calc(100vh - ${HEADER_HEIGHT}px - 40px)`,
  },
  cover: {
    bottom: 0,
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
  },
  full: {
    position: 'fixed',
    width: '100vw',
    height: '100vh',
  },
  loader: {
    zIndex: 5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}

export default styles
